// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-container {
  max-width: 600px;
  min-width: 290px;
  height: 119px;
  padding: 20px 16px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  cursor: pointer;
}

.card-content-1 {
  width: 100%;
  text-align: center;
  /* border: 1px solid red; */
}

.card-content-2 {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.card-title {
  font-size: 20px !important;
  font-weight: 500 !important;
  font-family: karla !important;
}

.card-designcount {
  font-weight: 700 !important;
  font-size: 22px !important;
  font-family: poppins !important;
}

.card-designcount-2 {
  font-weight: 400 !important;
  font-size: 18px !important;
  font-family: poppins !important;
}

.ledger-container-top {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  width: 100%;
}

.ledger-container-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 100%;
  white-space: nowrap;
}

.card-txt {
  font-size: 12px !important;
  font-weight: 500 !important;
  font-family: poppins !important;
  color: #8b8b8b !important;
}

.amount-box {
  display: flex;
  gap: 5px;
}

.amount-txt {
  font-family: poppins !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #50c878 !important;
}

.order-quote-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.order-quote-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
}

.order-quote-bottom-parent {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;
}

.order_quote-deatils {
  font-size: 16px !important;
  font-weight: 600 !important;
  font-family: poppins !important;
}

.order-quote-top-count {
  font-weight: 700 !important;
  font-size: 24px !important;
  font-family: poppins !important;
}

.wip-top-count {
  font-weight: 600 !important;
  font-size: 18px !important;
  font-family: poppins !important;
}
/* ── DUES CARD specific ─────────────────────────────────────── */
.dues-card .card-container {
  height: 140px;
  min-height: 140px;
}

.dues-card .ledger-container-bottom {
  align-items: flex-end;
  justify-content: space-between;
}

.dues-card .amount-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1 1;
}

.dues-card .amount-value {
  font-size: 15px !important;
  font-weight: 700 !important;
  font-family: Poppins, sans-serif !important;
  color: #ffffff;
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 4px;
}

.dues-card .amount-value.green {
  color: #50c878 !important;
}

.dues-card .amount-label {
  font-size: 11px !important;
  font-weight: 400 !important;
  font-family: Poppins, sans-serif !important;
  color: #6e6e6e;
  line-height: 1.2;
  text-align: center;
  width: 100%;
}
/* ── Equal size for Dues & Ledger cards ─────────────────────── */
.dues-card,
.ledger-card {
  width: 100%;
  flex: 1 1;
  min-width: 290px;
  max-width: 600px;
}

.dues-card .card-container,
/* ── Force equal height for Dues & Ledger ───────────────────── */
.ledger-card .card-container {
  height: 140px;
  min-height: 140px;
}
.card-container .MuiDivider-root {
  margin: 4px 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/ClientFlow/clientCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;AACjC;AACA,kEAAkE;AAClE;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA,kEAAkE;AAClE;;EAEE,WAAW;EACX,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".card-container {\n  max-width: 600px;\n  min-width: 290px;\n  height: 119px;\n  padding: 20px 16px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n}\n\n.card-content-1 {\n  width: 100%;\n  text-align: center;\n  /* border: 1px solid red; */\n}\n\n.card-content-2 {\n  width: 100%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n}\n\n.card-title {\n  font-size: 20px !important;\n  font-weight: 500 !important;\n  font-family: karla !important;\n}\n\n.card-designcount {\n  font-weight: 700 !important;\n  font-size: 22px !important;\n  font-family: poppins !important;\n}\n\n.card-designcount-2 {\n  font-weight: 400 !important;\n  font-size: 18px !important;\n  font-family: poppins !important;\n}\n\n.ledger-container-top {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 8px;\n  width: 100%;\n}\n\n.ledger-container-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  width: 100%;\n  white-space: nowrap;\n}\n\n.card-txt {\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  font-family: poppins !important;\n  color: #8b8b8b !important;\n}\n\n.amount-box {\n  display: flex;\n  gap: 5px;\n}\n\n.amount-txt {\n  font-family: poppins !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  color: #50c878 !important;\n}\n\n.order-quote-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.order-quote-bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 5px;\n}\n\n.order-quote-bottom-parent {\n  width: 100%;\n  text-align: center;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 12px;\n}\n\n.order_quote-deatils {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  font-family: poppins !important;\n}\n\n.order-quote-top-count {\n  font-weight: 700 !important;\n  font-size: 24px !important;\n  font-family: poppins !important;\n}\n\n.wip-top-count {\n  font-weight: 600 !important;\n  font-size: 18px !important;\n  font-family: poppins !important;\n}\n/* ── DUES CARD specific ─────────────────────────────────────── */\n.dues-card .card-container {\n  height: 140px;\n  min-height: 140px;\n}\n\n.dues-card .ledger-container-bottom {\n  align-items: flex-end;\n  justify-content: space-between;\n}\n\n.dues-card .amount-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  flex: 1;\n}\n\n.dues-card .amount-value {\n  font-size: 15px !important;\n  font-weight: 700 !important;\n  font-family: Poppins, sans-serif !important;\n  color: #ffffff;\n  line-height: 1.2;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.dues-card .amount-value.green {\n  color: #50c878 !important;\n}\n\n.dues-card .amount-label {\n  font-size: 11px !important;\n  font-weight: 400 !important;\n  font-family: Poppins, sans-serif !important;\n  color: #6e6e6e;\n  line-height: 1.2;\n  text-align: center;\n  width: 100%;\n}\n/* ── Equal size for Dues & Ledger cards ─────────────────────── */\n.dues-card,\n.ledger-card {\n  width: 100%;\n  flex: 1;\n  min-width: 290px;\n  max-width: 600px;\n}\n\n.dues-card .card-container,\n/* ── Force equal height for Dues & Ledger ───────────────────── */\n.ledger-card .card-container {\n  height: 140px;\n  min-height: 140px;\n}\n.card-container .MuiDivider-root {\n  margin: 4px 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
